import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import classNames from 'classnames';
import ReactSelectMaterialUi from 'react-select-material-ui';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ImagePreview from '../../components/molecules/ImagePreview';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import TabPanelDetail from '../../components/atoms/TabPanelDetail';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  rootPaper: {
    boxShadow: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  // detailTable: {
  //   width: 'auto'
  // },
  // tableCellItem: {
  //   border: '2px solid #ffffff',
  //   backgroundColor: '#e0e0e0'
  // },
  // tableCellData: {
  //   border: '2px solid #ffffff'
  // },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  marginBottom12: {
    marginBottom: '12px'
  },
  marginBottom5: {
    marginBottom: '5px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: 10,
    fontSize: 12,
    wordBreak: 'break-all'
  },
  // textSNS:
  detailTtl: {
    fontSize: 20,
    color: '#333333',
    padding: '15px 10px 10px'
  },
  tabpanelHeader: {
    padding: '0 2px',
    borderBottom: '2px solid #D8EBFF',
    minHeight: 'unset'
  },
  btnTabpanel: {
    padding: '5px 2px',
    backgroundColor: '#F7F7F7',
    borderRadius: '3px 3px 0 0',
    fontSize: 12,
    fontWeight: 600,
    color: '#777777',
    height: 'auto',
    minHeight: 'unset',
    borderTop: '5px solid #ffffff',
    width: '33%',
    minWidth: '100px',

    '&:first-child': {
      marginRight: 2
    },
    '&:last-child': {
      marginLeft: 2
    }
  },
  tabSelected: {
    backgroundColor: '#D8EBFF',
    fontWeight: 'bold',
    color: '#000000 !important',
    borderTopColor: '#D8EBFF'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    prefectures: state.commons.prefectures,
    statuses: state.shops.statuses,
    shopCategories: state.commons.shopCategories
  })),
  setPropTypes(propTypes),
  withState('shopName', 'setShopName', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefecture', 'setPrefecture', ''),
  withState('city', 'setCity', ''),
  withState('address1', 'setAddress1', ''),
  withState('address2', 'setAddress2', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('access', 'setAccess', ''),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('valueTab', 'setValueTab', 0),
  withState('translateType', 'setTranslateType', 0),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  lifecycle({
    componentDidMount() {
      this.props.setShopName(this.props.editConfirm.shopName);
      this.props.setShopNameKana(this.props.editConfirm.shopNameKana);
      this.props.setAddress1(this.props.editConfirm.address1);
      this.props.setAddress2(this.props.editConfirm.address2);
      this.props.setBuilding(this.props.editConfirm.building);
      this.props.setShopGroupName(this.props.editConfirm.shopGroupName);
      this.props.setShopContactName(this.props.editConfirm.shopContactName);
      this.props.setDepartment(this.props.editConfirm.department);
      this.props.setIntroduction(this.props.editConfirm.introduction);
      this.props.setBusinessHours(this.props.editConfirm.businessHours);
      this.props.setHoliday(this.props.editConfirm.holiday);
      this.props.setNearestStation(this.props.editConfirm.nearestStation);
      this.props.setAccess(this.props.editConfirm.access);
      this.props.setNumberSit(this.props.editConfirm.numberSit);
      this.props.setSmoking(this.props.editConfirm.smoking);
      this.props.setParking(this.props.editConfirm.parking);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    editAction,
    editConfirm,
    prefectures,
    shopCategories,
    enableShopBank,
    openEditProgress,
    progressOkAction,
    loading,
    resultMessage,
    valueTab,
    setValueTab,
    isLanguage,
    setIsLanguage,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    address1,
    // address2,
    setAddress1,
    setAddress2,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    access,
    setAccess,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    isFukuoka
  }) => {
    const handleChange = (event, newValueTab) => {
      setValueTab(newValueTab);
    };
    const setLanguage = v => {
      const lang = isLanguage;
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        if (
          !editConfirm.otherLanguages ||
          (editConfirm.otherLanguages && editConfirm.otherLanguages.length <= 0)
        ) {
          setShopName('');
          setShopNameKana('');
          setAddress1('');
          setAddress2('');
          setBuilding('');
          setShopGroupName('');
          setShopContactName('');
          setDepartment('');
          setIntroduction('');
          setBusinessHours('');
          setHoliday('');
          setNearestStation('');
          setAccess('');
          setNumberSit('');
          setSmoking('');
          setParking('');
        }
        // origin to other or other to other lang
        for (let k = 0; k < editConfirm.otherLanguages.length; k += 1) {
          if (editConfirm.otherLanguages[k].language === v) {
            if (
              editConfirm.otherLanguages[k].translateType &&
              editConfirm.otherLanguages[k].translateType === 1
            ) {
              // manual translation
              setShopName(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.shopName
                  ? editConfirm.otherLanguages[k].params.shopName
                  : ''
              );
              setShopNameKana(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.shopNameKana
                  ? editConfirm.otherLanguages[k].params.shopNameKana
                  : ''
              );
              setAddress1('Google Translate で自動的に翻訳されるもの');
              setAddress2('Google Translate で自動的に翻訳されるもの');
              setBuilding('Google Translate で自動的に翻訳されるもの');
              setShopGroupName(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.shopGroupName
                  ? editConfirm.otherLanguages[k].params.shopGroupName
                  : ''
              );
              setShopContactName(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.shopContactName
                  ? editConfirm.otherLanguages[k].params.shopContactName
                  : ''
              );
              setDepartment(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.department
                  ? editConfirm.otherLanguages[k].params.department
                  : ''
              );
              setIntroduction(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.introduction
                  ? editConfirm.otherLanguages[k].params.introduction
                  : ''
              );
              setBusinessHours(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.businessHours
                  ? editConfirm.otherLanguages[k].params.businessHours
                  : ''
              );
              setHoliday(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.holiday
                  ? editConfirm.otherLanguages[k].params.holiday
                  : ''
              );
              setNearestStation(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.nearestStation
                  ? editConfirm.otherLanguages[k].params.nearestStation
                  : ''
              );
              setAccess(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.access
                  ? editConfirm.otherLanguages[k].params.access
                  : ''
              );
              setNumberSit(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.numberSit
                  ? editConfirm.otherLanguages[k].params.numberSit
                  : ''
              );
              setSmoking(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.smoking
                  ? editConfirm.otherLanguages[k].params.smoking
                  : ''
              );
              setParking(
                editConfirm.otherLanguages[k].params &&
                  editConfirm.otherLanguages[k].params.parking
                  ? editConfirm.otherLanguages[k].params.parking
                  : ''
              );
            } else {
              // GG translation
              setShopName('Google Translate で自動的に翻訳されるもの');
              setShopNameKana('Google Translate で自動的に翻訳されるもの');
              setAddress1('Google Translate で自動的に翻訳されるもの');
              setAddress2('Google Translate で自動的に翻訳されるもの');
              setBuilding('Google Translate で自動的に翻訳されるもの');
              setShopGroupName('Google Translate で自動的に翻訳されるもの');
              setShopContactName('Google Translate で自動的に翻訳されるもの');
              setDepartment('Google Translate で自動的に翻訳されるもの');
              setIntroduction('Google Translate で自動的に翻訳されるもの');
              setBusinessHours('Google Translate で自動的に翻訳されるもの');
              setHoliday('Google Translate で自動的に翻訳されるもの');
              setNearestStation('Google Translate で自動的に翻訳されるもの');
              setAccess('Google Translate で自動的に翻訳されるもの');
              setNumberSit('Google Translate で自動的に翻訳されるもの');
              setSmoking('Google Translate で自動的に翻訳されるもの');
              setParking('Google Translate で自動的に翻訳されるもの');
            }
          }
        }
      } else if (v === languageType.ORIGIN) {
        // other to origin
        setShopName(editConfirm.shopName);
        setShopNameKana(editConfirm.shopNameKana);
        setAddress1(editConfirm.address1);
        setAddress2(editConfirm.address2);
        setBuilding(editConfirm.building);
        setShopGroupName(editConfirm.shopGroupName);
        setShopContactName(editConfirm.shopContactName);
        setDepartment(editConfirm.department);
        setIntroduction(editConfirm.introduction);
        setBusinessHours(editConfirm.businessHours);
        setHoliday(editConfirm.holiday);
        setNearestStation(editConfirm.nearestStation);
        setAccess(editConfirm.access);
        setNumberSit(editConfirm.numberSit);
        setSmoking(editConfirm.smoking);
        setParking(editConfirm.parking);
      }
      setIsLanguage(v);
    };
    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.detailTtl}>
          {isFukuoka ? '教室情報編集 確認' : '店舗情報詳細'}
        </Typography>
        <Paper className={classes.rootPaper}>
          <div className={classes.langDiv}>
            <ReactSelectMaterialUi
              required
              className={[classes.tableCell90, classes.textField]}
              defaultValue={isLanguage}
              value={isLanguage}
              options={languages}
              margin="normal"
              onChange={v => {
                setLanguage(v);
              }}
            />
          </div>
          <Tabs
            value={valueTab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered={!isFukuoka}
            className={classes.tabpanelHeader}
          >
            <Tab
              label="基本情報（必須）"
              className={classNames(
                classes.btnTabpanel,
                valueTab === 0 && classes.tabSelected
              )}
            />
            <Tab
              label="その他（任意）"
              className={classNames(
                classes.btnTabpanel,
                valueTab === 1 && classes.tabSelected
              )}
            />
            {!isFukuoka && (
              <Tab
                label="高度な設定（任意）"
                className={classNames(
                  classes.btnTabpanel,
                  valueTab === 2 && classes.tabSelected
                )}
              />
            )}
          </Tabs>

          {/* Required 基本情報（必須） */}
          <TabPanelDetail value={valueTab} index={0}>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '教室名' : '店舗名'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {shopName}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '教室名かな' : '店舗名かな'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {shopNameKana}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    郵便番号
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.zipCode}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    都道府県
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {prefectures.map(item => {
                      if (
                        editConfirm.prefectureCode.toString() ===
                        item.id.toString()
                      ) {
                        return item.name;
                      }
                      return '';
                    })}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    市区町村
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.city}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    町域・番地
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {address1}
                  </TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell className={classes.tableCellItem}>番地</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {address2}
                  </TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    建物名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {building}
                  </TableCell>
                </TableRow>
                {!isFukuoka && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      店舗カテゴリー
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {shopCategories.map(item => {
                        if (
                          editConfirm.shopCategoryId &&
                          editConfirm.shopCategoryId.toString() ===
                            item.id.toString()
                        ) {
                          return item.name;
                        }
                        return '';
                      })}
                    </TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    運営会社名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {shopGroupName}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    ご担当者名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {shopContactName}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    所属部署
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {department}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    電話番号（担当者）
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.contactPhone}
                  </TableCell>
                </TableRow>
                {!isFukuoka && !editConfirm.paymentGroupId && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        インボイス制度 適格事業者登録
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {editConfirm.haveRegistrationId ? '登録済み' : '未登録'}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        適格事業者登録番号
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {// eslint-disable-next-line no-nested-ternary
                        editConfirm.paymentGroupId
                          ? editConfirm.groupRegistrationId
                          : editConfirm.haveRegistrationId
                          ? editConfirm.registrationId
                          : undefined}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '教室電話番号' : '店舗電話番号'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.phone}
                    {/* {!roles.isShop && (
                  <frameElement>
                    {'('}
                    {editConfirm.showPhone ? `表示` : `非表示`}
                    {')'}
                  </frameElement>
                  )} */}
                  </TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    こども食堂設定
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {!roles.isShop && (
                    <frameElement>
                      {editConfirm.childShopFlag ? `設定済` : ``}
                    </frameElement>
                  )}
                  </TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メールアドレス
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.email}
                  </TableCell>
                </TableRow>
                {enableShopBank && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      {isFukuoka ? '振込先' : '売上受取方法'}
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.depositManageStr ===
                        '銀行口座で直接受取（月1回入金）（オプション）' &&
                      isFukuoka
                        ? '銀行口座'
                        : editConfirm.depositManageStr}
                    </TableCell>
                  </TableRow>
                )}
                {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      銀行名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.bankName}
                    </TableCell>
                  </TableRow>
                )}
                {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      支店名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.bankBranchName}
                    </TableCell>
                  </TableRow>
                )}
                {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      口座種別
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.bankAccountTypeStr}
                    </TableCell>
                  </TableRow>
                )}
                {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      口座番号
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.bankAccountNumber}
                    </TableCell>
                  </TableRow>
                )}
                {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      口座名義
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.bankAccountHolder}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TabPanelDetail>

          {/* Optional その他（任意） */}
          <TabPanelDetail value={valueTab} index={1}>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '教室概要' : '店舗概要'}
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellData, classes.breakLine]}
                  >
                    {introduction}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    営業時間
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {businessHours}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    定休日
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {holiday}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '平均金額' : '価格帯'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.priceRange}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    {isFukuoka ? '最寄り駅' : '最寄駅'}
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {nearestStation}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    アクセス
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {access}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    WebページURL
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.webPage}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>タグ</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.tagStr}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>画像</TableCell>
                  <TableCell className={classes.tableCellData}>
                    <ImagePreview previewImage={editConfirm.previewImage1} />
                    <ImagePreview previewImage={editConfirm.previewImage2} />
                    <ImagePreview previewImage={editConfirm.previewImage3} />
                    <ImagePreview previewImage={editConfirm.previewImage4} />
                    <ImagePreview previewImage={editConfirm.previewImage5} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>SNS</TableCell>
                  <TableCell className={classes.tableCellData}>
                    <div className={classes.margin}>
                      <Grid
                        container
                        spacing={1}
                        alignItems="center"
                        className={classes.marginBottom12}
                      >
                        <Grid item>
                          <CardMedia
                            component="img"
                            alt="Facebook"
                            height="24"
                            image="/images/icon_facebook.png"
                            title="Facebook"
                            className={classes.marginBottom5}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm
                          container
                          className={classes.textSNS}
                        >
                          {editConfirm.snsFacebook}
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={1}
                        alignItems="center"
                        className={classes.marginBottom12}
                      >
                        <Grid item>
                          <CardMedia
                            component="img"
                            alt="Twitter"
                            height="24"
                            image="/images/icon_twitter.png"
                            title="Twitter"
                            className={classes.marginBottom5}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm
                          container
                          className={classes.textSNS}
                        >
                          {editConfirm.snsTwitter}
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item>
                          <CardMedia
                            component="img"
                            alt="Instagram"
                            height="24"
                            image="/images/icon_instagram.png"
                            title="Instagram"
                            className={classes.marginBottom5}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm
                          container
                          className={classes.textSNS}
                        >
                          {editConfirm.snsInstagram}
                        </Grid>
                      </Grid>
                    </div>
                  </TableCell>
                </TableRow>
                {!isFukuoka && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        座席
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {numberSit}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        禁煙/喫煙
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {smoking}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    駐車場
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {parking}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TabPanelDetail>

          {/* Advanced 高度な設定（任意） */}
          <TabPanelDetail value={valueTab} index={2}>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    店舗詳細表示制限
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.stealthModeStr}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    誰でもごち制限
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.gochiRestrictionStr}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    社食ごちめし金額指定チケット利用の有無
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.allowMenuPriceShashoku
                      ? '利用する'
                      : '利用しない'}
                  </TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    社食ごちめし現金授受の有無
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.cashAllowed ? '受け付ける' : '受け付けない'}
                  </TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    差額決済利用可否
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.allowGapPayment
                      ? '可能 （券売機で営業または通販サービス）'
                      : '不可（上記以外）'}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TabPanelDetail>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={editAction} />
        </div>
        <ProgressDialog
          openProgress={openEditProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
